import { useCallback } from 'react';
import { useEffect } from 'react';
import { getNewItems } from 'apps/sigma2-ui/src/components/custom-viz/CustomVizHelpers';
import { CustomVizHookDropdownOptions } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const useHiringCopilotUpdateDropdownsEffect = ({
  dropdownOptions,
  setSelectedDepartments,
  setSelectedRoles,
  setSelectedLocations,
  shouldPrefillFilters,
}: {
  dropdownOptions: CustomVizHookDropdownOptions;
  setSelectedDepartments: Setter<string[]>;
  setSelectedRoles: Setter<string[]>;
  setSelectedLocations: Setter<string[]>;
  shouldPrefillFilters: boolean;
}) => {
  const handler = useCallback(() => {
    setSelectedDepartments(
      getNewItems({
        options: dropdownOptions,
        dropdownId: 'department',
      }),
    );

    setSelectedRoles(
      getNewItems({
        options: dropdownOptions,
        dropdownId: 'job_title',
      }),
    );

    setSelectedLocations(
      getNewItems({
        options: dropdownOptions,
        dropdownId: 'location',
      }),
    );
  }, [
    dropdownOptions,
    setSelectedDepartments,
    setSelectedRoles,
    setSelectedLocations,
  ]);

  useEffect(() => {
    if (!shouldPrefillFilters) {
      return;
    }

    handler();
  }, [handler, shouldPrefillFilters]);

  return handler;
};
